var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserHelmetSafety = function SvgUserHelmetSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#userHelmetSafety_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.813.164c-1.143 0-2.063.92-2.063 2.063v4.812l-2.44-4.89c-3.266 1.753-5.552 5.114-5.793 9.015H8.5c-1.143 0-2.062.92-2.062 2.063s.919 2.062 2.062 2.062h22c1.143 0 2.063-.92 2.063-2.062 0-1.143-.92-2.063-2.063-2.063h-.017c-.24-3.901-2.527-7.262-5.792-9.015L22.25 7.04V2.227c0-1.143-.92-2.063-2.062-2.063zM11.8 30.414c-6.377 0-11.55 5.173-11.55 11.55 0 1.212.988 2.2 2.2 2.2h34.1c1.212 0 2.2-.988 2.2-2.2 0-6.376-5.173-11.55-11.55-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.586 15.29c-.06.446-.086.91-.086 1.374 0 6.076 4.924 11 11 11s11-4.924 11-11c0-.464-.026-.928-.086-1.375z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "userHelmetSafety_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25.164h38.5v44H.25z"
  })))));
};
export default SvgUserHelmetSafety;